import { render, staticRenderFns } from "./DarkHeader.vue?vue&type=template&id=4bc14662&"
import script from "./DarkHeader.vue?vue&type=script&lang=js&"
export * from "./DarkHeader.vue?vue&type=script&lang=js&"
import style0 from "./DarkHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports